var andySelectCallback = function(variant, selector) {
  
  if($(".multipleVariants").length) {
       
       var variant_id = $("#masterProduct select[name=id]").val();

       var stock_level = [];
       $("#avail-list td[data-stockvariant='"+variant_id+"']").children('span').each(function(id, value) {
           var text = $(this).text();
           stock_level.push($.trim(text));
       });        

       if(stock_level.length > 0) {

          var existingValue = $("#addToCart").val();
          var stock_output = stock_level.join(" ");

          var new_value = '<span class="stockValueNextToButton">' + $.trim(stock_output) + '</span>';

          if($('span.stockValueNextToButton').length) {
             $("span.stockValueNextToButton").text($.trim(stock_output));
          } else {
             $("#addToCart").before(new_value);
//               $("#widget-fave-html").after(new_value);
          }
       }

  }
  
  
   var $product = $('#product-' + selector.product.id);
    var $notify_form = $('#notify-form-' + selector.product.id);

    if (variant && variant.featured_image && $product.is(":visible")) {
      var $slider = $('#product_slider', $product);
      var original_image = $(".flex-active-slide img", $product), new_image = variant.featured_image;
      Shopify.Image.switchImage(new_image, original_image[0], function (new_image_src, original_image, element) {
        if ($slider.length) {
          $slider.flexslider($('[data-image-id="' + variant.featured_image.id + '"]').data('index'));
        } else {
          $(element, $product).attr('src', new_image_src);
        }
      });
    }

    if (variant && variant.available == true) {
      if(variant.price < variant.compare_at_price){
        $('.was_price', $product).html(Shopify.formatMoney(variant.compare_at_price, $('form.product_form', $product).data('money-format')))        
      } else {
        $('.was_price', $product).text('')
      } 

      

      $('.sold_out', $product).text('');
      $('.current_price', $product).html(Shopify.formatMoney(variant.price, $('form.product_form', $product).data('money-format')));
      $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').val('Add to Cart');
      $notify_form.hide();
    } else {
      var message = variant ? "Sold Out" : "Out of Stock";    
      $('.was_price', $product).text('');
      $('.current_price', $product).text('');
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');      
      $('.sold_out', $product).text(message);
      $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').val(message); 
      $notify_form.fadeIn();
    }

    
    
  if(variant.inventory_quantity > 0){
    $('.lead-time').hide();
  }
  else {
    $('.lead-time').show();
  }
   
}


function stocklevels2() {

  $("#masterProduct .single-option-selector").each(function(index, element) { 

      // Get's the ID of the select element. 
      var elementId = $(this).attr("id");
    
      // Loop through each selects option.
      $("#masterProduct #"+elementId+ " option").each(function(id, value) {

          var optionId = $(this).val();
          var existingValue = $(this).text();
        
          //This code checks if the option is a complex stock level or not. 
          var stock_level = [];
        
          $("#avail-list td.stockMatch[data-stockmatch='"+optionId+"']").each(function(id, value) {
            	
              $(this).next('.complexstocklevel').children('span').each(function(id, value) {
                   var text = $(this).text();
                   stock_level.push($.trim(text));
              });
          });
        
          if(stock_level.length > 0) {

              var stock_output = stock_level.join(" ");

              var new_value = existingValue + ' - ' + $.trim(stock_output);

              $(this).text(new_value);
          }
        
      });
  });
  
  if($('#masterProduct #selectedVariantId').length) {
   		
    var id = $('#masterProduct #selectedVariantId').val();
    
    var stock_level = [];
    
    $("#avail-single li span").each(function(id, value) {
      	var text = $(this).text();
        stock_level.push($.trim(text));
    });
    
    if(stock_level.length > 0) {

        var existingValue = $("#addToCart").val();
        var stock_output = stock_level.join(" ");

        var new_value = '<span class="stockValueNextToButton">' + $.trim(stock_output) + '</span>';

        $("#addToCart").before(new_value);
//        $("#widget-fave-html").after(new_value);
    }
  }
  
};

$( document ).ready(function() {
  
  stocklevels2();

});